import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";
import { StyledBarGraph } from "./style";
import { useEffect, useState } from "react";
import { ACCENT_COLOR } from "../../../consts/const";

/**
 *
 * @param {Object} param
 * @param {Array} param.data
 * @param {string} param.xKey
 * @param {string[]} param.yKey
 * @param {string} param.yKey.label
 * @param {string} param.yKey.key
 * @param {function} [param.tickFormmatter]
 * @param {string} [param.yLabel]
 * @param {boolean} [param.multiGraphMode]
 * @param {boolean} [param.defaultView]
 * @param {string} [param.unit] - y축 단위
 * @returns
 */
export const BarGraph = ({
  data,
  xKey,
  yKey,
  tickFormmatter,
  yLabel,
  multiGraphMode,
  defaultView,
  unit,
  showLabels,
}) => {
  const [currentViewKey, setCurrentViewKey] = useState(
    defaultView ? defaultView : Object.keys(data).pop()
  );
  const COLOR = [
    "#5987D2",
    "#F06548",
    "#ffc549",
    "#FD51A3",
    "#3577F1",
    "#51ADF6",
    "#1EC9B7",
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload) {
      return (
        <div className="custom-tooltip">
          <p className="label">{label}</p>
          <div className="wrap">
            {payload.map((item, idx) => {
              const value = item.value;
              return (
                <p key={idx} style={{ color: item.color }}>
                  <span>{item.name}: </span> {value.toLocaleString("ko-KR")}
                  {unit && unit}
                </p>
              );
            })}
          </div>
        </div>
      );
    }
  };

  // const CustomLabel = (props) => {
  //   const { x, y, value, width, fill, stroke, strokeWidth } = props;
  //   if (value === 0) return null;
  //   return (
  //     <text
  //       x={x + width / 2}
  //       y={y}
  //       fill={fill}
  //       stroke={stroke}
  //       strokeWidth={strokeWidth}
  //       textAnchor="middle"
  //       dy={-6}
  //     >
  //       {value}
  //     </text>
  //   );
  // };

  useEffect(() => {
    setCurrentViewKey(Object.keys(data).pop());
  }, [data]);

  return (
    <StyledBarGraph>
      <div className="graph-wrap">
        {data && (multiGraphMode ? data[currentViewKey] : data) && (
          <BarChart
            width={1300}
            height={300}
            data={multiGraphMode ? data[currentViewKey] : data}
            margin={{ top: 30 }}
          >
            <XAxis
              tickSize={12}
              dataKey={xKey}
              tickFormatter={(value) =>
                tickFormmatter ? tickFormmatter(value) : value
              }
            />
            <YAxis
              tickSize={12}
              tickCount={5}
              label={
                yLabel && {
                  value: yLabel,
                  angle: -90,
                  position: "insideLeft",
                }
              }
            />
            <CartesianGrid stroke="#ddd" strokeDasharray="0" />
            <ReferenceLine y={0} stroke="#090808" />
            <Tooltip content={<CustomTooltip />} />
            {Object.keys(...yKey).includes("label") && yKey.length > 1 && (
              <Legend />
            )}
            {yKey.map((y, idx) => (
              <Bar
                key={idx}
                dataKey={y.key}
                fill={COLOR[idx]}
                barSize={32}
                // label={{
                //   position: "top",
                //   fill: COLOR[idx],
                //   stroke: COLOR[idx],
                //   strokeWidth: "0.4",
                //   content: <CustomLabel colorIndex={idx} />,
                // }}
                animationDuration={500}
                {...(y.label ? { name: y.label } : {})}
              >
                {showLabels && (
                  <LabelList
                    dataKey={data.key}
                    position="top"
                    fill={COLOR[idx]}
                    formatter={(value) => value.toLocaleString()}
                  />
                )}
              </Bar>
            ))}
          </BarChart>
        )}
        {multiGraphMode && (
          <div className="button-wrap">
            {Object.keys(data).map((key, index) => (
              <button
                key={index}
                className={key === currentViewKey ? "active" : ""}
                onClick={() => setCurrentViewKey(key)}
              >
                <span
                  className="circle"
                  style={{ backgroundColor: ACCENT_COLOR[index] }}
                />
                <p>{key}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </StyledBarGraph>
  );
};
